import * as _ from 'lodash';

export const create = (state = {}, action) => {
    switch (action.type) {

        default:
            return state;
    }
};
